import kebabCase from "lodash/kebabCase";
import Link from "next/link";

import { useJuneSoEventTracking } from "@stadium/services/june-analytics/hooks/use-june-so-event-tracking";

import { stopEventPropagation } from "@stadium/helpers/resource";
import { getShopSendItemsRoute } from "@helpers/routes";

import { DEFAULT_SERVICES } from "@constants/june-so";

const SelectItemsCta = ({
  className = "",
  pageName = "",
  feUrl = "",
  storeName = "",
  storeNumber = "",
}) => {
  const { trackEvent } = useJuneSoEventTracking({ services: DEFAULT_SERVICES });

  const handlePreviewTemplateClicked = (e) => {
    stopEventPropagation(e);
    trackEvent({
      componentName: kebabCase(pageName),
      target: "select-items",
      eventProperties: { shop_name: storeName, shop_number: storeNumber },
    });
  };

  return (
    <Link
      href={getShopSendItemsRoute(feUrl)}
      className={className}
      onClick={handlePreviewTemplateClicked}
      title="Select Items"
    >
      Select Items
    </Link>
  );
};

export default SelectItemsCta;
